<script setup lang="ts">
import IOHeroMedia from "@/components/io/io-hero/layers/IOHeroMedia.vue";
import IOHeroShapes from "@/components/io/io-hero/layers/IOHeroShapes.vue";
import IOHeroContent from "@/components/io/io-hero/layers/IOHeroContent.vue";
import IOHeroOverlays from "@/components/io/io-hero/layers/IOHeroOverlays.vue";
import IOHeroDivider from "@/components/io/io-hero/layers/IOHeroDivider.vue";
// ⚠️ Could not locate IOHeroScrollActions.vue
// This file should essentially orchestrate the IOHero component

// Each aspect manages its own state and transitions, however we want to get to the point where each aspect collects what t needs, 
// but the orchastration of everything happens in here, if something is cancelled it it cancelled and reset here etc
// We can thing of think component as the timeline in rev slider essentially, where we could create delays and things of this nature, to explore later

// const { $io } = useNuxtApp()
import { useIOStore } from '@/stores/io'
const $io = useIOStore()

const key = computed(() => $io.hero.key ? $io.hero.key : 'default')

const heroBase = computed(() => $io.heroBaseObject)
const heroMedia = computed(() => $io.heroMediaObject) // global media settings object
const heroContent = computed(() => $io.heroContentObject) // global content settings object
const heroShapes = computed(() => $io.heroShapesObject) // global shapes settings object
const heroOverlays = computed(() => $io.heroOverlaysObject) // global overlays settings object
const heroDivider = computed(() => $io.heroDividerObject) // global divider settings object

const contentModel = computed(() => heroContent.value?.model || 'page')

const baseHeight = computed(() => heroBase.value.height || '')
const baseMinHeight = computed(() => heroBase.value.minHeight || '')
const baseMaxHeight = computed(() => heroBase.value.maxHeight || '')
</script>

<template>
  <div class="io-hero" :style="{ 
    height: baseHeight ?? 'auto', 
    minHeight: baseMinHeight ?? 'auto', 
    maxHeight: baseMaxHeight ?? 'auto' 
  }" :class="[key, 'content-model-' + contentModel, 'transition-all transition-duration-1000']">


    <template v-if="true"> <!-- debug  -->

      <IOHeroMedia :id="key" :media="heroMedia" />
      
      <!-- <IOHeroShapes :id="key" :shapes="heroShapes" /> -->

      <IOHeroContent :id="key" :content="heroContent" />

      <IOHeroOverlays v-if="heroOverlays" :id="key" :overlays="heroOverlays" />

      <IOHeroDivider :id="key" :divider="heroDivider" />

    </template>

    <!-- <IOHeroShapes :id="key" :shapes="heroShapes" /> -->

    <!-- The ability to click to scroll down -->
    <!-- <IOHeroScrollActions :id="key" :scrollActions="heroScrollActions" /> -->

    <slot name="dividers" />

  </div>
</template>

<style>



</style>

<style lang="scss" scoped> 

.io-hero {
  display:flex;
  flex-direction: column;
  width:100%;
  height:100%;

  display:grid;
  grid-template-areas: "layer";

  // This is temporary
  // min-height: 800px;

  // transition: min-height 1s ease-in-out;

  transition: min-height 1s ease-in-out, max-height 1s ease-in-out, height 1s ease-in-out;

  .layer {
    grid-area: layer;
    &.layer-media {
      z-index: 10;
    }
    &.layer-shapes {
      z-index: 11;
    }
    &.layer-overlays {
      z-index: 12;
    }
    &.layer-content {
      z-index: 14;
    }
    &.layer-dividers {
      z-index: 13;
    }
  }

  &.content-model-page {
    // background: var(--example-color);
    min-height: 800px;
  }

  &.content-model-product {
    // background: blue;
  }
}

.hero-slide {
  width:100%;
  height:100%;
}

:deep(.io-hero-overlay) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &.gradient {
   
  }

  &.texture {

  }
}


</style>